module.exports = __webpack_public_path__ + "media/images/logos/app-logo-navy-3c1750bf96aa85ae1627738829e23e56.svg";